var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 141.127,
    cy: 278.3933,
    r: 356.7029,
    fx: 488.6835,
    fy: 358.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5B79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FA5574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4472,
    style: {
      stopColor: "#EC4C51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    style: {
      stopColor: "#9543C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3857B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)"
    },
    d: "M249.7,0.6C111.8,0.6,0,112.4,0,250.3 S111.8,500,249.7,500s249.7-111.8,249.7-249.7S387.6,0.6,249.7,0.6z M341.2,228.6l-112.5,174c-1.1,1.7-2.9,2.7-4.9,2.7 c-0.5,0-1.1-0.1-1.6-0.2c-2.5-0.7-4.2-3-4.2-5.6V280.6h-54.4c-2.1,0-4.1-1.2-5.1-3c-1-1.9-0.9-4.1,0.2-5.9L271.3,97.4 c1.4-2.2,4-3.1,6.5-2.4c2.5,0.7,4.2,3,4.2,5.6v119.1h54.4h0c2.1,0,4.1,1.2,5.1,3C342.5,224.5,342.4,226.8,341.2,228.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171700785134071559870000001975877982761945482_",
    cx: 238.8272,
    cy: 262.1001,
    r: 12.4681,
    gradientTransform: "matrix(-24 0 0 22.2006 6000.853 -5577.5024)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000",
      stopOpacity: 0.5673
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    style: {
      stopColor: "#5E2548",
      stopOpacity: 0.04641108
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#68294F",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "none",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000171700785134071559870000001975877982761945482_)"
    },
    cx: 249.7,
    cy: 250.3,
    r: 249.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000044174211438965553140000000900254890455243416_",
    cx: 238.9611,
    cy: 263.0777,
    r: 10.576,
    gradientTransform: "matrix(1.469576e-15 24 28.9591 -1.773236e-15 -7350.7031 -5498.5298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68294F",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#5E2548",
      stopOpacity: 0.04641108
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D060B",
      stopOpacity: 0.4374
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "none",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000044174211438965553140000000900254890455243416_)"
    },
    cx: 249.7,
    cy: 250.3,
    r: 249.7
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae0df49519ba03155d845b520631c925.svg";
export { ForwardRef as ReactComponent };